import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import config from '../config/config'
import { useAuth, AuthContext } from '../contexts/AuthContext'
import { LOGIN_PATH } from '../config/routes'
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext'

const ManageItemAddPhotos = ({ item, itemType, handleAddPhotos }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { token } = useAuth()
  const { logout } = useContext(AuthContext)

  const [selectedPhotos, setSelectedPhotos] = useState([])

  const handleFileChange = (e) => {
    const files = e.target.files
    setSelectedPhotos(files)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const formData = new FormData()
      formData.append('item', item.id)
      formData.append('item-type', itemType)

      for (let i = 0; i < selectedPhotos.length; i++) {
        formData.append(`photo_${i}`, selectedPhotos[i])
      }

      await axios.post(`${config.apiUrl}photo`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      handleAddPhotos()
      setFlashMessage(t('SUCCESS_CREATED_MESSAGE'), 'success')
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      }

      setFlashMessage(t('ERROR_MESSAGE'), 'error')
      console.error('Erreur lors du chargement POST photo')
    }
  }

  return (
    <div>
      <h2>{t('ADD_PHOTOS')}</h2>
      <div className="p-3">
        <div style={{ maxWidth: '400px', margin: 'auto' }}>
          <Form onSubmit={handleSubmit} encType="multipart/form-data">
            <Form.Group controlId="formFileMultiple" className="mb-3">
              <Form.Label>Sélectionner des photos</Form.Label>
              <Form.Control type="file" multiple onChange={handleFileChange} />
            </Form.Group>
            <div className="text-center" style={{ marginBottom: '60px' }}>
              <Button variant="primary" type="submit">
                {t('SEND')}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default ManageItemAddPhotos
